<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-document-orders"
      title="Documentary settlement"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="xl"
      no-close-on-backdrop
    >
      <b-table
        ref="ref-table-document-orders"
        sticky-header="50vh"
        small
        class="position-relative font-small-3"
        table-class="text-nowrap"
        :fields="fields"
        :items="documentOrders"
        :empty-text="$t('No matching records found')"
      >
        <template #cell(code)="data">
          <div class="d-flex justify-content-center">
            <b-form-checkbox v-model="data.item.is_approved">
            </b-form-checkbox>
            <div>
              {{data.item.code}}
            </div>
          </div>
        </template>
        <template #cell(total_volume)="data">
          {{ totalVolume(data.item.total_volume) }}
        </template>
        <template #cell(total_weight)="data">
          {{ totalVolume(data.item.total_weight) }}
        </template>

      </b-table>
      <div class="d-flex justify-content-end px-2">
        Total documents: {{ totalDocs }}
      </div>

      <template #modal-footer>
        <b-container fluid>
          <b-row>
            <b-col class="d-flex align-items-center justify-content-end p-0">
              <b-button
                class="mr-1"
                @click="$emit('hideModal', false)"
                v-t="'CANCEL'"
              >
              </b-button>
              <b-button variant="primary" @click="approveDocuments()">
                {{ $t("SAVE") }}
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
  </div>
</template>

<script>
/* Service */
import DocumentarySettlementsService from "@/views/operations/views/documentary-settlements/services/documentary-settlements.service.js";
import Fields from "@/views/operations/views/documentary-settlements/data/settlements-detail.field.js";
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      fields: Fields,
      documentOrders: [],
    };
  },
  props: {
    travelOrderId: {
      type: Number,
      default: null,
    },
  },
  mounted() {
    this.toggleModal("modal-document-orders");
  },
  async created() {
    // this.addPreloader();
    // try {
    await this.getDocumentOrders();
    //   await this.getDepartments();
    // } catch (error) {
    //   this.showToastError("Proceso fallido", "Error")
    // } finally {
    //   this.removePreloader();
    // }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser"
    }),
    totalDocs(){
      return this.documentOrders.length;
    }
  },
  methods: {
    async getDocumentOrders() {
      const params = {        
        travelOrderId: this.travelOrderId,
      };
      const { data } = await DocumentarySettlementsService.getDocumentOrders(
        params
      );
      this.documentOrders = data;
    },
    async approveDocuments(){
      let documentApprovedList = this.documentOrders.filter(item => item.is_approved == 1);
      const params = {
        userId: this.currentUser.employee_id,
        documentApprovedList: documentApprovedList
      }
      const { data } = await DocumentarySettlementsService.approveDocuments(params);
    },
    totalVolume(volume){
      return volume ?? "--";
    },
    totalWeigth(weigth){
      return weigth ?? "--";
    },
    hideModal() {
      this.$emit("hideModal");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>